module.exports = __webpack_public_path__ + "static/media/rodrigo.d2203b9d.jpg";